import { useEffect, useState } from "react";
import useDesertEye from "./hooks/useDesertEye";
import useAnchor from "./hooks/useAnchor";
import { LangContext } from "./LangContext";
import Header from "./components/Header";
import TabBar from "./components/TabBar";
import NewsTab from "./components/tabs/NewsTab";
import UnverifiedTab from "./components/tabs/UnverifiedTab";
import DeeperTab from "./components/tabs/DeeperTab";
import IdeaTab from "./components/tabs/IdeaTab";
import AnchorTab from "./components/tabs/AnchorTab";
import ArticleDetail from "./components/ArticleDetail";
import PCApp from "./pc/PCApp";

console.log("[DESERT-EYE] v6.0 loaded", new Date().toISOString());

const PC_BREAKPOINT = 1024;

function MobileApp() {
  const [lang, setLang] = useState("ko");
  const {
    tab, time, news, loading, error, lastFetch,
    ach, cuiBono, scenarios, topArticles, subScenariosMap, subLoadingIdx, themes,
    deepLoading, deepError,
    sel, autoIdeas, autoIdeaL, ideaIn, ideas, ideaL, ideaErr,
    unverifiedPanel,
    panelRef,
    byTier, socmint, adversary, adversaryFrame,
    switchTab, load, genIdeas, genMoreIdeas, handleOverride, closeSel,
    setSel, setIdeaIn, setUnverifiedPanel, handleLoadSubScenarios,
  } = useDesertEye();

  const anchor = useAnchor({ news, scenarios });

  return (
    <LangContext.Provider value={lang}>
    <div className="min-h-screen flex flex-col bg-bg-primary text-text-primary font-sans md:max-w-2xl md:mx-auto md:w-full">
      <Header time={time} lastFetch={lastFetch} lang={lang} setLang={setLang} />
      <TabBar activeTab={tab} onTabChange={switchTab} />

      <div ref={panelRef} className="flex-1 overflow-y-auto min-h-0">
        {tab === "news" && (
          <NewsTab
            news={news} loading={loading} error={error} byTier={byTier} themes={themes}
            onLoad={load} onSelectArticle={setSel} onOverride={handleOverride}
          />
        )}
        {tab === "unverified" && (
          <UnverifiedTab
            socmint={socmint} adversary={adversary} adversaryFrame={adversaryFrame}
            unverifiedPanel={unverifiedPanel} setUnverifiedPanel={setUnverifiedPanel}
            onSelectArticle={setSel} onOverride={handleOverride}
          />
        )}
        {tab === "deeper" && (
          <DeeperTab
            deepLoading={deepLoading} deepError={deepError}
            ach={ach} cuiBono={cuiBono} scenarios={scenarios} topArticles={topArticles}
            subScenariosMap={subScenariosMap} subLoadingIdx={subLoadingIdx}
            onLoadSubScenarios={handleLoadSubScenarios}
          />
        )}
        {tab === "idea" && (
          <IdeaTab
            ideaIn={ideaIn} ideas={ideas} autoIdeas={autoIdeas}
            ideaL={ideaL} autoIdeaL={autoIdeaL} ideaErr={ideaErr}
            onIdeaInputChange={setIdeaIn} onGenIdeas={genIdeas} onMore={genMoreIdeas}
          />
        )}
        {tab === "anchor" && (
          <AnchorTab
            directionKeyword={anchor.directionKeyword}
            onDirectionChange={anchor.setDirectionKeyword}
            briefing={anchor.briefing}
            briefingTs={anchor.briefingTs}
            collectedSources={anchor.collectedSources}
            generating={anchor.generating}
            error={anchor.error}
            sourceStatuses={anchor.sourceStatuses}
            phase={anchor.phase}
            onGenerate={anchor.generate}
          />
        )}
      </div>

      <ArticleDetail article={sel} onClose={closeSel} onOverride={handleOverride} />
    </div>
    </LangContext.Provider>
  );
}

export default function DesertEye() {
  // ?layout=mobile / ?layout=pc 강제 옵션. 기본은 viewport.
  const [layout, setLayout] = useState(() => {
    if (typeof window === "undefined") return "mobile";
    const q = new URLSearchParams(window.location.search).get("layout");
    if (q === "pc" || q === "mobile") return q;
    return window.innerWidth >= PC_BREAKPOINT ? "pc" : "mobile";
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const q = new URLSearchParams(window.location.search).get("layout");
    if (q === "pc" || q === "mobile") return; // 쿼리 강제 시 리사이즈 무시

    const onResize = () => {
      const next = window.innerWidth >= PC_BREAKPOINT ? "pc" : "mobile";
      setLayout(prev => prev === next ? prev : next);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return layout === "pc" ? <PCApp /> : <MobileApp />;
}
